import React, { useReducer, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import RawEmbed from '../RawEmbed';

const createIntrovokeUrl = (introvokeEventId, userToken) => {
    const userTokenQuery = userToken ? `?authKey=${userToken}` : '';
    return `https://embed.introvoke.com/event/${introvokeEventId}${userTokenQuery}`;
};

export default function IntrovokeEmbed({ introvokeEventId, userToken, shouldRefreshEmbeds, dataQa }) {
    const stableUserToken = useRef(userToken).current;
    const introvokeEmbedUrl = createIntrovokeUrl(introvokeEventId, stableUserToken);
    const [key, forceUpdate] = useReducer((x) => x + 1, 0);

    useEffect(() => {
        shouldRefreshEmbeds && forceUpdate();
    }, [shouldRefreshEmbeds]);

    return (
        <RawEmbed
            embedUrl={introvokeEmbedUrl}
            customIFrameAttributes={{
                key,
                title: 'splash studio embed',
                frameBorder: '0',
                allow: 'camera *; microphone *; autoplay; display-capture *',
                allowFullScreen: true,
            }}
            dataQa={dataQa}
        />
    );
}

IntrovokeEmbed.propTypes = {
    introvokeEventId: PropTypes.string.isRequired,
    userToken: PropTypes.string,
    shouldRefreshEmbeds: PropTypes.bool.isRequired,
    dataQa: PropTypes.string,
};

IntrovokeEmbed.defaultProps = {
    userToken: undefined,
    dataQa: 'splash-studio-embed',
};
